
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <b>Viehtransporte in der Schweiz</b>
    <br />
    <br />
    <p>{`Die rund 1.4 Millionen Rinder in der Schweiz werde pro Jahr insgesamt etwa 1.8 Millionen Mal meist in Lastwagen an einen anderen Ort gebracht. Sie legten x Millionen Kilometer zurück. (Karte der Bewegungen eines Tages).
Das “durchschnittliche” Rind legt in seinem Leben 46 Kilometer zurück - zu Fuss oder im Transporter, die am weitesten gereiste Kuh reiste 1454 Kilometer - von x bis y. (Ev. genauer Weg zeigen).`}</p>
    <p>{`Am xx Juni wechselten X Kühe ihren Standort (z.Bsp. auf die Alp, in die Tierklinik, zu einem anderen Hof oder zum Schlachthof).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;